import { ProductsAndServices24, OnlineViewers24, Support24, Search24 } from "@hig/icons";
import { FaGoogle, FaProductHunt } from 'react-icons/fa';
import { IoIosPricetags } from 'react-icons/io';

const Icons = {
  onlinePrices: IoIosPricetags,
  onlinePromotions: OnlineViewers24,
  resellerAffiliates: ProductsAndServices24,
  googleShopping: FaGoogle,
  productCatalogue: FaProductHunt,
  salesContact: Support24,
  searchEngineOptimization: Search24
};

export default Icons;
